import * as React from "react";

interface IDialogETextProps {
  isShowDialogText: boolean;
}

class DialogEText extends React.Component<IDialogETextProps> {
  constructor(props: IDialogETextProps) {
    super(props);
  }

  public render() {
    return (
      <svg
        className={`dialogE-text ${this.props.isShowDialogText ? "show" : ""}`}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 152.217 105.309"
      >
        <g>
          <path
            fill="#2D4670"
            d="M37.183,31.033h6.221v1.421H31.882v3.646c-0.013,4.024-0.91,6.935-2.693,8.729
			c-0.357-0.424-0.72-0.774-1.086-1.054c-0.023-0.011-0.041-0.022-0.051-0.033c1.08-1.114,1.777-2.614,2.09-4.499
			c-0.201,0.123-0.893,0.524-2.074,1.204l-0.518-1.472c0.278-0.111,1.209-0.557,2.793-1.338c0.021-0.735,0.033-1.254,0.033-1.555
			v-5.051h5.15v-1.94h1.656V31.033z M30.259,35.515l-1.254,0.669c-0.156-0.902-0.547-1.934-1.17-3.094
			c-0.023-0.056-0.045-0.101-0.068-0.134l1.172-0.568c0.623,1.037,1.053,2.04,1.287,3.011
			C30.237,35.442,30.248,35.481,30.259,35.515z M38.671,39.462v3.512h4.732v1.405H31.63v-1.405h1.89v-5.619h1.472v5.619h2.157
			v-7.593h-4.298V34.01h10.018v1.371h-4.197v2.71h3.947v1.371H38.671z"
          />
          <path
            fill="#2D4670"
            d="M60.479,35.599h-3.997c0.412,3.779,1.817,6.395,4.215,7.844c-0.424,0.278-0.814,0.702-1.17,1.271
			c-1.874-1.192-3.173-3.149-3.897-5.87c-0.681,2.509-2.08,4.511-4.198,6.004c-0.199-0.346-0.508-0.719-0.92-1.12v1.07h-1.488
			v-5.854h-1.504v0.418c-0.012,2.241-0.541,3.931-1.59,5.067c-0.322-0.256-0.725-0.507-1.203-0.752
			c0.902-0.981,1.354-2.426,1.354-4.332v-0.401h-1.203v-1.438h4.146v-2.157h-2.842v-0.017h-0.653v-5.485h1.438v4.063h2.057v-4.8
			h1.488v14.417c2.186-1.595,3.49-3.803,3.914-6.623c0.057-0.412,0.1-0.848,0.135-1.305h-3.48v-1.572h3.529v-0.117v-4.8h1.521v4.816
			v0.101h4.349V35.599z M60.195,32.605l-1.338,0.686c-0.412-0.893-1.043-1.856-1.889-2.894c-0.057-0.078-0.113-0.145-0.169-0.2
			l1.271-0.603c0.882,0.981,1.566,1.935,2.057,2.859C60.15,32.511,60.173,32.561,60.195,32.605z"
          />
          <path
            fill="#2D4670"
            d="M63.773,36.953c-0.524,0-0.908-0.234-1.153-0.702c-0.112-0.212-0.167-0.435-0.167-0.669
			c0-0.568,0.233-0.981,0.703-1.237c0.188-0.111,0.395-0.168,0.617-0.168c0.525,0,0.904,0.234,1.139,0.703
			c0.111,0.223,0.166,0.457,0.166,0.702c0,0.568-0.229,0.976-0.686,1.221C64.191,36.903,63.986,36.953,63.773,36.953z
			 M63.773,43.677c-0.535,0-0.92-0.229-1.153-0.687c-0.112-0.211-0.167-0.439-0.167-0.686c0-0.568,0.233-0.98,0.703-1.237
			c0.188-0.111,0.395-0.167,0.617-0.167c0.525,0,0.904,0.234,1.139,0.702c0.111,0.224,0.166,0.457,0.166,0.702
			c0,0.58-0.24,0.993-0.719,1.238C64.181,43.632,63.986,43.677,63.773,43.677z"
          />
          <path
            fill="#2D4670"
            d="M30.277,55.497v-1.756c-0.346,0.368-0.781,0.775-1.305,1.221c-0.379-0.368-0.82-0.713-1.322-1.037
			c1.249-0.858,2.303-2.018,3.161-3.479c0.167-0.268,0.312-0.535,0.435-0.803l1.557,0.435c-0.213,0.446-0.486,0.932-0.82,1.455
			h10.537v1.389h-1.69v2.575h2.324v1.438h-2.324v2.575h2.074v1.438h-14.7v-1.438h2.074v-2.575h-2.342v-1.438H30.277z M29.289,65.381
			l-1.504-0.635c0.757-0.636,1.389-1.589,1.889-2.86c0.045-0.134,0.09-0.262,0.134-0.385l1.54,0.385
			C30.833,63.38,30.148,64.545,29.289,65.381z M31.714,52.922v2.575h1.589v-2.575H31.714z M31.714,56.936v2.575h1.589v-2.575H31.714
			z M32.802,62.003l1.471-0.15c0.268,1.26,0.412,2.297,0.435,3.11l-1.556,0.234C33.152,64.249,33.037,63.185,32.802,62.003z
			 M34.641,55.497h1.655v-2.575h-1.655V55.497z M36.296,56.936h-1.655v2.575h1.655V56.936z M36.23,62.02l1.488-0.234
			c0.523,1.138,0.875,2.175,1.055,3.111l-1.59,0.317C37.015,64.177,36.699,63.112,36.23,62.02z M39.34,55.497v-2.575h-1.688v2.575
			H39.34z M39.34,59.511v-2.575h-1.688v2.575H39.34z M39.641,61.919l1.505-0.484c1.027,1.282,1.779,2.408,2.258,3.378l-1.605,0.568
			C41.32,64.345,40.601,63.19,39.641,61.919z"
          />
          <path
            fill="#2D4670"
            d="M52.603,53.272h7.023c0,0.012-0.012,0.273-0.033,0.786c-0.269,4.895-0.574,7.961-0.92,9.198
			c-0.157,0.524-0.334,0.909-0.536,1.154c-0.367,0.435-0.858,0.691-1.472,0.77c-0.043,0.011-0.083,0.017-0.117,0.017
			c-0.579,0.056-1.482,0.056-2.709,0c-0.045-0.558-0.234-1.109-0.568-1.656c0.758,0.067,1.628,0.101,2.608,0.101
			c0.357-0.011,0.619-0.095,0.786-0.251c0.469-0.445,0.825-2.386,1.07-5.819c0.045-0.792,0.096-1.684,0.151-2.676h-5.353
			c-0.256,3.612-1.494,6.483-3.711,8.612c-0.749,0.725-1.607,1.372-2.576,1.94c-0.258-0.401-0.637-0.809-1.137-1.221
			c-0.046-0.022-0.079-0.045-0.102-0.067c3.345-1.929,5.257-4.771,5.736-8.529c0.033-0.245,0.062-0.49,0.084-0.735h-5.302v-1.623
			h5.401v-0.435v-3.161h1.674v3.161V53.272z"
          />
          <path
            fill="#2D4670"
            d="M68.589,55.146c1.193,0.947,2.369,2.09,3.529,3.428c0.101,0.123,0.195,0.234,0.284,0.335
			l-1.454,1.254c-1.183-1.438-2.438-2.709-3.764-3.813L68.589,55.146z"
          />
          <path
            fill="#2D4670"
            d="M80.33,64.88l-1.305-0.92c1.138-0.658,1.912-1.745,2.325-3.262l1.421,0.485
			c-0.512,1.75-1.287,2.96-2.324,3.629C80.402,64.835,80.363,64.857,80.33,64.88z M79.945,53.925l-0.101-1.438l2.525-0.018
			c0.837-0.947,1.522-1.89,2.058-2.826l1.756,0.568c-0.491,0.636-1.138,1.383-1.939,2.241c1.203-0.011,3.133-0.039,5.787-0.083
			c-0.703-0.491-1.244-0.842-1.623-1.054l1.17-0.887c1.527,0.836,2.921,1.84,4.182,3.011c0.268,0.245,0.496,0.474,0.686,0.686
			l-1.204,1.037c-0.401-0.469-0.913-0.965-1.538-1.489C86.406,53.797,82.487,53.881,79.945,53.925z M92.086,54.979v4.6h-5.618
			c1.08,0.58,1.872,1.12,2.375,1.622l-1.07,1.054c-0.592-0.636-1.512-1.293-2.761-1.974c-0.11-0.056-0.212-0.105-0.301-0.15
			l0.585-0.552h-3.563v-4.6H92.086z M90.515,58.273v-2.007h-7.291v2.007H90.515z M86.066,63.692h2.592
			c0.357,0,0.58-0.111,0.67-0.335c0.089-0.212,0.15-0.624,0.184-1.237c0.334,0.268,0.787,0.451,1.354,0.552
			c0.033,0.011,0.056,0.017,0.066,0.017c-0.111,1.115-0.362,1.823-0.751,2.124c-0.291,0.212-0.742,0.317-1.355,0.317h-2.91
			c-1.082,0-1.771-0.189-2.074-0.568c-0.2-0.29-0.301-0.741-0.301-1.354v-2.476h1.557v2.459c0,0.245,0.094,0.396,0.283,0.451
			C85.515,63.675,85.744,63.692,86.066,63.692z M90.416,61.25l1.287-0.735c1.114,0.858,2.012,1.795,2.691,2.81
			c0.146,0.223,0.263,0.429,0.352,0.618l-1.388,0.804c-0.413-0.881-1.183-1.856-2.309-2.927
			C90.837,61.607,90.626,61.418,90.416,61.25z"
          />
          <path
            fill="#2D4670"
            d="M97.288,57.755L96,57.304c0.424-1.148,0.703-2.653,0.836-4.516l1.238,0.15
			c-0.078,1.729-0.324,3.289-0.736,4.683C97.315,57.666,97.298,57.711,97.288,57.755z M102.053,54.594l-1.087,0.586
			c-0.233-0.825-0.602-1.678-1.104-2.559v12.727h-1.539V49.66h1.539v2.927l1.037-0.484
			C101.458,53.072,101.841,53.903,102.053,54.594z M111.704,52.253h-6.205c-0.122,0.313-0.262,0.607-0.417,0.886h5.803v1.138h-2.426
			v1.204h3.128v1.188h-7.86V55.48h3.295v-1.204h-2.006v-1.004c-0.793,1.528-1.83,2.737-3.112,3.63
			c-0.233-0.323-0.601-0.686-1.104-1.087c1.327-0.814,2.358-2.002,3.095-3.563h-2.191v-1.237h2.692
			c0.146-0.479,0.257-0.932,0.335-1.355l1.506,0.201c-0.079,0.356-0.18,0.741-0.301,1.154h5.769V52.253z M110.767,57.537v6.289
			c0,0.612-0.14,1.014-0.418,1.204c-0.067,0.044-0.134,0.083-0.201,0.117c-0.391,0.155-1.177,0.233-2.357,0.233
			c-0.045-0.356-0.184-0.803-0.418-1.338c0.758,0.034,1.293,0.039,1.605,0.017c0.167-0.056,0.256-0.139,0.267-0.251v-1.003h-5.067
			v2.575h-1.504v-7.844H110.767z M109.245,58.708h-5.067v0.937h5.067V58.708z M104.177,61.702h5.067v-0.971h-5.067V61.702z"
          />
          <path
            fill="#2D4670"
            d="M118.527,57.521c0-0.858,0.34-1.555,1.02-2.09c0.49-0.391,1.043-0.586,1.656-0.586
			c0.881,0,1.59,0.346,2.125,1.037c0.367,0.491,0.551,1.037,0.551,1.639c0,0.87-0.346,1.572-1.037,2.107
			c-0.479,0.379-1.025,0.568-1.639,0.568c-0.859,0-1.555-0.34-2.09-1.02C118.722,58.697,118.527,58.146,118.527,57.521z
			 M119.564,57.521c0,0.592,0.256,1.054,0.77,1.389c0.277,0.167,0.568,0.251,0.869,0.251c0.602,0,1.064-0.257,1.389-0.77
			c0.166-0.268,0.25-0.558,0.25-0.87c0-0.602-0.256-1.064-0.77-1.388c-0.268-0.167-0.557-0.251-0.869-0.251
			c-0.58,0-1.037,0.245-1.371,0.736C119.654,56.896,119.564,57.197,119.564,57.521z"
          />
        </g>
      </svg>
    );
  }
}

export default DialogEText;



// WEBPACK FOOTER //
// ./src/fearCity/components/DialogEText.tsx